const config: { [key: string]: any } = {
  development: {
    base_url: 'http://localhost:3001',
    paystack_key: 'pk_test_c54a439094eefddd130967f9f36101f4c30e7576'
  },
  staging: {
    base_url: 'http://172.20.90.130:3001',
    paystack_key: 'pk_test_c54a439094eefddd130967f9f36101f4c30e7576'
  },
  production: {
    base_url: 'https://iwillsapi.azurewebsites.net',
    paystack_key: 'pk_live_14815c87fa4377e875ecf5fc167833bd2066a80b'
  }
};

export default config[
  (import.meta.env.VITE_NODE_ENV as string) || 'development'
];
